import { success, info, error } from 'react-notification-system-redux'
import store from '../../store/configureStore'

const showNotification = (displayMethod, message) => {
  const notificationOpts = {
    title: '',
    message,
    autoDismiss: 5,
  }
  store.dispatch(displayMethod(notificationOpts))
}

const showErrorNotification = message => showNotification(error, message)
const showInfoNotification = message => showNotification(info, message)
const showSuccessNotification = message => showNotification(success, message)

export default {
  showErrorNotification,
  showInfoNotification,
  showSuccessNotification,
}



// WEBPACK FOOTER //
// ./src/utils/notifications/notificationsUtils.js